export enum DocumentStatus {
  NOT_LOADED = 'status',
  LOAD_PENDING = 'LOAD_PENDING',
  LOADED = 'LOADED',
}

export const getDocumentStatus = (status: string) => {
  const values = Object.values(DocumentStatus);
  const found = values.find((value) => value === status);
  if (found) {
    return found;
  }
  throw Error('Unsuported document status');
};
